import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { PreferenceV2Name } from 'app-components/flux/preferences-v2/preferencesV2Names';
import type { PreferenceV2, PreferenceV2Props } from 'app-components/flux/preferences-v2/preferencesV2Types';

import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';

const syncPreferencesV2PayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<PreferenceV2Props>>();
const preferenceV2PayloadCreator = getPayloadCreator<PreferenceV2 | PreferenceV2Props>();

export const getPreferencesV2 = createAction('GET_PREFERENCES_V2', getPayloadCreator());
export const getPreferencesV2Success = createAction('GET_PREFERENCES_V2_SUCCESS', syncPreferencesV2PayloadCreator);
export const getPreferencesV2Failure = createAction('GET_PREFERENCES_V2_FAILURE', errorPayloadCreator);

export const getSpecificPreferenceV2 = createAction(
  'GET_SPECIFIC_PREFERENCES_V2',
  getPayloadCreator<{ id: PreferenceV2Name }>(),
);
export const getSpecificPreferenceV2Success = createAction(
  'GET_SPECIFIC_PREFERENCES_V2_SUCCESS',
  syncPreferencesV2PayloadCreator,
);
export const getSpecificPreferenceV2Failure = createAction('GET_SPECIFIC_PREFERENCES_V2_FAILURE', errorPayloadCreator);

export const updatePreferenceOverride = createAction('UPDATE_PREFERENCE_OVERRIDE', preferenceV2PayloadCreator);
export const updatePreferenceOverrideSuccess = createAction(
  'UPDATE_PREFERENCE_OVERRIDE_SUCCESS',
  preferenceV2PayloadCreator,
);
export const updatePreferenceOverrideFailure = createAction('UPDATE_PREFERENCE_OVERRIDE_FAILURE', errorPayloadCreator);

export const applyPreferenceChanges = createAction('APPLY_PREFERENCE_CHANGES', syncPreferencesV2PayloadCreator);

export const resetPreferenceOverride = createAction(
  'RESET_PREFERENCE_OVERRIDE',
  getPayloadCreator<{ id: PreferenceV2Name; defaultValue?: any }>(),
);
